import React from 'react'
import BasicLayout from '../../layouts/BasicLayout'
import ImageSlider from '../../components/user/ImageSlider'
import MetaTag from '../../components/user/MetaTag'

function MainPage() {
  return (
    <BasicLayout>
      <div className="w-screen h-screen">
        <MetaTag
          title="더룸 디자인"
          description="더룸(THEROOM)은 구축 아파트 리모델링, 부분 시공, 설계부터 시공까지 책임지는 인테리어 스튜디오입니다. 내 집에 딱 맞는 리모델링을 상담부터 시공, A/S까지 함께합니다."
          imgsrc="https://www.theroom.co.kr/assets/logos/og-image.png"
          url="https://www.theroom.co.kr"
        />
        <ImageSlider />
      </div>
    </BasicLayout>
  )
}

export default MainPage